import { jobsConstants } from '../_constants';

import { jobsService } from '../_services/jobs.service';

export const jobsActions = {
  AddJob,
  removeSlot,
  recentVacanciesAction,
  detailJobAction,
  detailVacancyAction,

  showForm,
  searchVacanciesAction,
  setModalFilters,
  searchVacanciesModalAction,

  searchCompaniesAction,
  searchCompaniesByIdAction,

  searchApplicantsAction,
  getApplicantDetail,

  searchCompaniesSummaryByIdAction,

  searchApplications,
  applyJobAction,
};

function applyJobAction(id) {
  return async (dispatch) => {
    try {
      await jobsService.applyJob(id);
      dispatch({
        type: jobsConstants.SUCCESS,
        payload: true,
      });

      setTimeout(() => {
        dispatch({
          type: jobsConstants.SUCCESS,
          payload: false,
        });
      }, 100);
    } catch (err) {
      dispatchError(dispatch, err);
    }
  };
}

function showForm() {
  return (dispatch, getState) => {
    const { showForm } = getState().jobsForm;

    dispatch({
      type: jobsConstants.SHOW_FORM,
      payload: !showForm,
    });
  };
}

function AddJob(data) {
  return (dispatch, getState) => {
    const { jobs } = getState().jobsForm;

    const langsUpdated = [...jobs];
    langsUpdated.push(data);

    dispatch({
      type: jobsConstants.UPDATE_JOBS,
      payload: langsUpdated,
    });
  };
}

function removeSlot(idx) {
  return (dispatch, getState) => {
    const { jobs } = getState().jobsForm;

    const langsUpdated = [...jobs];
    langsUpdated.splice(idx, 1);

    dispatch({
      type: jobsConstants.UPDATE_JOBS,
      payload: langsUpdated,
    });
  };
}

function recentVacanciesAction() {
  return async (dispatch) => {
    try {
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: true,
      });

      const response = await jobsService.recentVacancies();

      dispatch({
        type: jobsConstants.UPDATE_REQUEST_JOBS,
        payload: response.data.results,
      });
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: false,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    } finally {
      dispatch({ type: jobsConstants.UPDATE_LOADING, payload: false });
    }
  };
}

function searchVacanciesAction(text) {
  return async (dispatch, getState) => {
    const { filters } = getState().jobsForm;

    const newFilters = { ...filters };
    newFilters.q = text;

    try {
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: true,
      });
      const response = await jobsService.searcRecentVacancies(newFilters);

      dispatch({
        type: jobsConstants.UPDATE_REQUEST_JOBS,
        payload: response.data.results,
      });
      dispatch({
        type: jobsConstants.UPDATE_FILTERS,
        payload: newFilters,
      });
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: false,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    } finally {
      dispatch({ type: jobsConstants.UPDATE_LOADING, payload: false });
    }
  };
}

function searchVacanciesModalAction(_text) {
  return async (dispatch, getState) => {
    const { filters } = getState().jobsForm;

    const newFilters = { ...filters };

    if (newFilters.days && newFilters.days.length) {
      newFilters.days = newFilters.days.join('');
    } else {
      newFilters.days = null;
    }

    try {
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: true,
      });
      const response = await jobsService.searcRecentVacancies(newFilters);

      dispatch({
        type: jobsConstants.UPDATE_REQUEST_JOBS,
        payload: response.data.results,
      });
      dispatch({
        type: jobsConstants.UPDATE_FILTERS,
        payload: newFilters,
      });
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: false,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    } finally {
      dispatch({ type: jobsConstants.UPDATE_LOADING, payload: false });
    }
  };
}

function setModalFilters(filtersModal) {
  return async (dispatch, getState) => {
    const { filters } = getState().jobsForm;

    let newFilters = {
      ...filters,
    };

    if (!filtersModal) {
      delete newFilters.salary;
      delete newFilters.type;
      delete newFilters.days;
    } else {
      newFilters = {
        ...newFilters,
        ...filtersModal,
      };
    }

    dispatch({
      type: jobsConstants.UPDATE_FILTERS,
      payload: newFilters,
    });
  };
}

function detailJobAction(id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: true,
      });
      const response = await jobsService.detailJob(id);
      dispatch({
        type: jobsConstants.UPDATE_REQUEST_DETAIL_JOBS,
        payload: response.data,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    }

    dispatch({
      type: jobsConstants.UPDATE_LOADING,
      payload: false,
    });
  };
}

function detailVacancyAction(id) {
  return async (dispatch) => {
    try {
      const response = await jobsService.detailVacancies(id);
      dispatch({
        type: jobsConstants.UPDATE_REQUEST_DETAIL_JOBS,
        payload: response.data,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    }
  };
}

function getApplicantDetail(id) {
  return async (dispatch) => {
    try {
      const response = await jobsService.ApplicantDetail(id);

      dispatch({
        type: jobsConstants.UPDATE_REQUEST_DETAIL_APPLICANT_JOBS,
        payload: response.data,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    }
  };
}

function searchCompaniesAction(text) {
  return async (dispatch) => {
    try {
      const newFilters = {
        q: text,
      };
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: true,
      });
      const response = await jobsService.searchCompanies(newFilters);

      dispatch({
        type: jobsConstants.UPDATE_COMPANIES,
        payload: response.data.results,
      });
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: false,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    } finally {
      dispatch({ type: jobsConstants.UPDATE_LOADING, payload: false });
    }
  };
}

function searchApplicantsAction(text) {
  return async (dispatch) => {
    try {
      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: true,
      });
      const newFilters = {
        q: text,
      };
      const response = await jobsService.searchApplicants(newFilters);

      dispatch({
        type: jobsConstants.UPDATE_APPLICANTS,
        payload: response.data.results,
      });

      dispatch({
        type: jobsConstants.UPDATE_LOADING,
        payload: false,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    } finally {
      dispatch({ type: jobsConstants.UPDATE_LOADING, payload: false });
    }
  };
}

function searchApplications(text) {
  return async (dispatch) => {
    dispatch({
      type: jobsConstants.UPDATE_LOADING,
      payload: true,
    });
    try {
      const newFilters = {
        q: text,
      };
      const response = await jobsService.searchApplications(newFilters);

      dispatch({
        type: jobsConstants.UPDATE_APPLICANTIONS,
        payload: response.data.results,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    }

    dispatch({
      type: jobsConstants.UPDATE_LOADING,
      payload: false,
    });
  };
}

function searchCompaniesByIdAction(id) {
  return async (dispatch) => {
    try {
      const response = await jobsService.getCompanyById(id);

      const newResponse = {
        data: {},
        results: response.data.results,
      };

      dispatch({
        type: jobsConstants.UPDATE_COMPANIES_DETAIL_JOBS,
        payload: newResponse,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    }
  };
}

function searchCompaniesSummaryByIdAction(id) {
  return async (dispatch) => {
    try {
      const response = await jobsService.getCompanySummaryById(id);

      dispatch({
        type: jobsConstants.UPDATE_COMPANIES_DETAIL,
        payload: response.data,
      });
    } catch (err) {
      dispatchError(dispatch, err);
    }
  };
}

function dispatchError(dispatch, error) {
  dispatch({
    type: jobsConstants.UPDATE_ERROR,
    payload: error,
  });
}
